import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ConfigService } from '../services/config.service';
import { LogglyService } from '../services/loggly.service';

/**
 * On the '**' (404) route: the 404 page is only for a logged-in user who opened a page that does not exist.
 * Not logged in -> the login page instead. logoutUser picks the login (ConfigService.isServicenearSession):
 * ServiceNear seller -> ServiceNear (with the key in the URL the login page signs in again by itself), Tobeonline -> /public/login.
 */
export const notFoundGuard: CanActivateFn = (route, state) => {
  const configService = inject(ConfigService);
  const logglyService = inject(LogglyService);

  const loginDetails = JSON.parse(localStorage.getItem('admin_Details') ?? 'null');
  if (loginDetails?.UserID) {
    return true;
  }
  logglyService.log('notFoundGuard - not logged in on an unknown page, sending to login: ' + state.url);
  configService.logoutUser();
  return false;
};
